import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { Title, Text } from "../../components/units/Text"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useValidatePermission } from "../../roles/roles"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../components/Rest/Organization"
import { ImageInput } from "../../components/Form/ImageInput"
import { useEffect, useState } from "react"
import { AxiosFetchSelf,AxiosPatchSelf, PatchUser } from "../../components/Rest/RestUsers"
import { PhoneInput_ } from "../../components/Form/FormInput"

interface ResponseProps {
    errors: {
        phone?: string;
        email?: string;
        organization_id?: string;
    },
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | undefined;
    created: boolean;
}


const defaultResponse = (): ResponseProps => {
    return {
        errors: {

        },
        requestState: RestApiState.Idle,
        timeOutId : undefined,
        created: false
    }
}


export const UpdateSelf = () => {
    const { user } = useSignedInContext()

    useValidatePermission({ role : user.role, resource: 'Users', action: 'update' })
    
    const [response, setResponse] = useState<ResponseProps>(defaultResponse)
    const [data, setData] = useState<PatchUser>({email: "", organization_id: {organization_name: ""}})
    const [changes, setChanges] = useState<any>({})
    const [phone, setPhone] = useState<string>("")

    useEffect(() =>{
        AxiosFetchSelf(user.role_slug, (value: PatchUser) => { 
            setData(value);
            if (value.phone) { setPhone(value.phone) }
            setChanges((prev:any) => ({...prev, id: value.id}))
        })
    }, [])

    useEffect(() => { 
        if (response.requestState === RestApiState.Success) {
            setResponse(prev => ({...prev,  created: true}))
        }
    }, [response.requestState])

    const handleSubmit = (event: any) => {
        event.preventDefault();
        setResponse(prev => ({...prev, errors:{}}))

        const formData = new FormData(event.currentTarget)
        const formValues: Record<string, any> = {};
        formData.forEach((value, key) => {
            if (key in changes) {
                formValues[key] = value as any; // Cast value to string if necessary
            } 
        });
        formValues['id'] = changes.id
        formValues['phone'] = phone

        setResponse(prev => ({...prev, requestState: RestApiState.Pending}))
        AxiosPatchSelf(
            user.role_slug,
            formValues as PatchUser, 
            (value: RestApiState) => {
                setResponse(prev => ({...prev, requestState: value}))
            },
            (value: any) => {
                for (const [key, val] of Object.entries(value)) {
                    setResponse(prev => ({...prev, errors: {
                        ...prev.errors, [key]: "Неверное значение или дубль"
                    }}))
                }
            }
        )
    }

    return (
        <ContentWrapper>
            <Title>Профиль</Title>
            <br />
            <BoxWrapper 
                bg="bg-primary"
                p="p2"
                r="r10"
                style={{
                    maxWidth: "640px"
                }} 
            >
                {  data ? (
                    <form onSubmit={ handleSubmit } className="show-up-quick">
                        <FlexWrapper justifyContent="center">
                            <BoxWrapper>
                                <ImageInput 
                                    disabled={false}
                                    name="profile_image"
                                    size="base"
                                    defaultImg="profile"
                                    previewImg={changes.profile_image ? changes.profile_image : data.profile_image}
                                    setPreview={{
                                        action: "",
                                        key: "",
                                        setValue: (action:string, key:string, value: any) => { 
                                            setChanges((prev:any) => ({ ...prev, profile_image: value }) ) 
                                        }
                                    }}
                                />
                                <Text color="secondary" className="text-center">Аватар</Text>
                            </BoxWrapper>
                        </FlexWrapper>
                        <Input name="email"
                            label="Почта"
                            required={false}
                            type='text'
                            inputError={response.errors.email}
                            value={data.email}
                            disabled={true}
                        />
                        <PhoneInput_ name="phone"
                            value={phone}
                            setter={setPhone}
                            label="Телефон"
                            required={true}
                            type='text'
                            inputError={response.errors.phone} 
                        />
                        <Input name="last_name"
                            label="Фамилия"
                            required={false}
                            type='text'
                            value={data.last_name}
                            setter={(e: any) => { 
                                    setData(prev => ({...prev, last_name: e.target.value}))
                                    setChanges((prev:any) => ({...prev, last_name: e.target.value})) 
                                }
                            }
                        />
                        <Input name="first_name"
                            label="Имя"
                            required={false}
                            type='text'
                            value={data.first_name}
                            setter={(e: any) => { 
                                    setData(prev => ({...prev, first_name: e.target.value})) 
                                    setChanges((prev:any) => ({...prev, first_name: e.target.value})) 
                                }
                            }
                        />
                        <Input name="middle_name"
                            label="Отчество"
                            required={false}
                            type='text'
                            value={data.middle_name}
                            setter={(e: any) => { 
                                    setData(prev => ({...prev, middle_name: e.target.value})) 
                                    setChanges((prev:any) => ({...prev, middle_name: e.target.value})) 
                                }
                            }
                        />

                        <Input name="organization_id"
                            label="Организация"
                            required={false}
                            type='text'
                            value={data.organization_id?.organization_name}
                            disabled={true}
                        />

                        <SubmitButton 
                            restState={response.requestState}
                            disabled={false}
                            restHandler={{
                                timeOutId: null,
                                setter: (key: "timeOutId" | "requestState", value: any) => {
                                    setResponse(prev => ({...prev, [key]: value}))
                                }
                            }}
                        />
                    </form>
                ) : (
                    <BoxWrapper className="show-up-quick">
                        <FlexWrapper>
                            <Text className="bold">Пользователь успешно создан ✅</Text>
                        </FlexWrapper>
                    </BoxWrapper>
                ) }
            </BoxWrapper>
        </ContentWrapper>
    )
}